import { defineMessages } from 'react-intl';

export default defineMessages({
  whatExpensesAreYouClaimingFor: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.whatExpensesAreYouClaimingFor',
    defaultMessage: 'What expenses are you claiming for?',
  },
  repatriationBenefitReturnOfRemains: {
    id: 'fastCover.stepOtherTugo.repatriationBenefitReturnOfRemains',
    defaultMessage: 'Repatriation Benefit (Return of Remains)',
  },
  repatriationBurialAtPlaceOfDeath: {
    id: 'fastCover.stepOtherTugo.repatriationBurialAtPlaceOfDeath',
    defaultMessage: 'Repatriation (Burial at place of death)',
  },
  returnHomeBenefit: {
    id: 'fastCover.stepOtherTugo.returnHomeBenefit',
    defaultMessage: 'Return Home Benefit',
  },
  deathRemainsBenefit: {
    id: 'fastCover.stepOtherTugo.deathRemainsBenefit',
    defaultMessage: 'Return of remains to home country',
  },
  deathBurialBenefit: {
    id: 'fastCover.stepOtherTugo.deathBurialBenefit',
    defaultMessage: 'Burial or Cremation at Place of Death',
  },
  deathTransportBenefit: {
    id: 'fastCover.stepOtherTugo.deathTransportBenefit',
    defaultMessage: 'Transportation of Family Member to Identify Remains when required',
  },
  deathExpensesDisclaimer: {
    id: 'fastCover.stepOtherTugo.deathExpensesDisclaimer',
    defaultMessage: 'Expenses related to death are payable only when pre-approved by us. Charges for funeral expenses, coffin or urn are not eligible for reimbursement.',
  },
  amountClaimed: {
    id: 'fastCover.stepOtherTugo.amountClaimed',
    defaultMessage: 'Amount claimed',
  },
  currency: {
    id: 'fastCover.stepOtherTugo.currency',
    defaultMessage: 'Currency',
  },
  selectInsuredForExpense: {
    id: 'fastCover.stepOtherTugo.selectInsuredForExpense',
    defaultMessage: 'Select the insured for this expense',
  },
  expenseFor: {
    id: 'fastCover.stepOtherTugo.expenseFor',
    defaultMessage: 'Expense For',
  },
  descriptionOfExpense: {
    id: 'fastCover.stepOtherTugo.descriptionOfExpense',
    defaultMessage: 'Description of Expense',
  },
  isRequired: {
    id: 'fastCover.stepOtherTugo.isRequired',
    defaultMessage: '\'{defaultMessage}\' is required',
  },
  addItem: {
    id: 'fastCover.stepOtherTugo.addItem',
    defaultMessage: 'Add Expense',
  },
  dateOfExpenses: {
    id: 'fastCover.stepOtherTugo.dateOfExpenses',
    defaultMessage: 'Date of Expense',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.StepOther/messages.js